import { resolveMarketPath } from "../config/builder-routes.js";

export function translateDom(root, t, formatCurrency, marketContext) {
  root.querySelectorAll("[data-i18n]").forEach((element) => {
    element.textContent = t(element.dataset.i18n);
  });

  root.querySelectorAll("[data-i18n-placeholder]").forEach((element) => {
    element.setAttribute("placeholder", t(element.dataset.i18nPlaceholder));
  });

  root.querySelectorAll("[data-i18n-title]").forEach((element) => {
    const translatedTitle = t(element.dataset.i18nTitle);
    const bootstrapTooltipInitialized = element.hasAttribute(
      "data-bs-original-title",
    );

    // Bootstrap moves a tooltip's title to data-bs-original-title when the
    // tooltip is initialized. Market config is loaded asynchronously, so an
    // instance may already exist by the time translations are applied.
    if (bootstrapTooltipInitialized) {
      element.setAttribute("data-bs-original-title", translatedTitle);
      element.removeAttribute("title");
    } else {
      element.setAttribute("title", translatedTitle);
    }
  });

  root.querySelectorAll("[data-i18n-aria-label]").forEach((element) => {
    element.setAttribute("aria-label", t(element.dataset.i18nAriaLabel));
  });

  root.querySelectorAll("[data-i18n-alt]").forEach((element) => {
    element.setAttribute("alt", t(element.dataset.i18nAlt));
  });

  root.querySelectorAll("[data-i18n-src]").forEach((element) => {
    element.setAttribute("src", t(element.dataset.i18nSrc));
  });

  root.querySelectorAll("[data-i18n-currency]").forEach((element) => {
    element.textContent = formatCurrency(element.dataset.i18nCurrency);
  });

  root.querySelectorAll("[data-i18n-price]").forEach((element) => {
    element.textContent = t(element.dataset.i18nPrice, {
      price: formatCurrency(element.dataset.price),
    });
  });

  root.querySelectorAll("[data-i18n-content]").forEach((element) => {
    element.setAttribute("content", t(element.dataset.i18nContent));
  });

  root.querySelectorAll("[data-i18n-href]").forEach((element) => {
    element.setAttribute("href", t(element.dataset.i18nHref));
  });

  root.querySelectorAll("[data-market-url]").forEach((element) => {
    const path = resolveMarketPath(marketContext, element.dataset.marketUrl);
    element.setAttribute(
      element.tagName === "META" ? "content" : "href",
      `${marketContext.services.woocommerceBaseUrl}/${path}`,
    );
  });

  root.querySelectorAll("[data-market-locale]").forEach((element) => {
    element.setAttribute("content", marketContext.locale.replace("-", "_"));
  });
}
